import { PayloadAction } from "@reduxjs/toolkit";
import { put, takeEvery, call } from "redux-saga/effects";
import { ReceiveActions } from "redux/actions";
import { IReceiveDocument } from "model/IReceive/IReceive";
import { IPaginationRequest } from "model/Common/IPaginationRequest";
import { IPaginateApiResponse } from "model/Common/IPaginateApiResponse";
import { IErrorResponse } from "model/Common/IErrorResponse";
import ReceiveApiService from "services/ReceiveApiService";
import { IImportPalletDetail } from "model/IReceive/IImportPalletDetail";
import {
  IApiResponse,
  IDeleteByIdRequest,
  IReceiveDetail,
  IGetReceiveDetailRequest,
  IImportReceiveDocumentRequest,
  IUpdateReceiveDocument,
} from "model";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";

function* getAllReceives(action: PayloadAction<IPaginationRequest>) {
  try {
    const result: IPaginateApiResponse<IReceiveDocument[]> = yield call(
      ReceiveApiService.getAllReceives,
      action.payload
    );
    if (result.succeeded) {
      yield put(ReceiveActions.getAllReceives.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(ReceiveActions.getAllReceives.failed(error));
    }
  } catch (error) {
    yield put(ReceiveActions.getAllReceives.failed(error));
  }
}

function* getReceiveDetail(action: PayloadAction<IGetReceiveDetailRequest>) {
  try {
    const result: IPaginateApiResponse<IReceiveDetail[]> = yield call(
      ReceiveApiService.getReceiveDetail,
      action.payload
    );
    if (result.succeeded) {
      yield put(ReceiveActions.getReceiveDetail.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(ReceiveActions.getReceiveDetail.failed(error));
    }
  } catch (error) {
    yield put(ReceiveActions.getReceiveDetail.failed(error));
  }
}
function* getImportPalletDetail(
  action: PayloadAction<IGetReceiveDetailRequest>
) {
  try {
    const result: IPaginateApiResponse<IImportPalletDetail[]> = yield call(
      ReceiveApiService.getImportPalletDetail,
      action.payload
    );
    if (result.succeeded) {
      yield put(ReceiveActions.getImportPalletDetail.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(ReceiveActions.getImportPalletDetail.failed(error));
    }
  } catch (error) {
    yield put(ReceiveActions.getImportPalletDetail.failed(error));
  }
}

function* updateReceiveDocument(action: PayloadAction<IUpdateReceiveDocument>) {
  try {
    const result: IApiResponse<IReceiveDocument> = yield call(
      ReceiveApiService.updateReceiveDocument,
      action.payload
    );
    if (result.succeeded) {
      yield put(ReceiveActions.updateReceiveDocument.success(result.data!));
      AlertHelper.showAlert("Update Document Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(ReceiveActions.updateReceiveDocument.failed(error));
    }
  } catch (error) {
    yield put(ReceiveActions.updateReceiveDocument.failed(error));
  }
}

function* deleteReceiveDocument(action: PayloadAction<IDeleteByIdRequest>) {
  try {
    const result: IApiResponse<any> = yield call(
      ReceiveApiService.deleteReceiveDocument,
      action.payload
    );
    if (result.succeeded) {
      yield put(ReceiveActions.deleteReceiveDocument.success(result.data));
      AlertHelper.showAlert("Delete Document Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(ReceiveActions.deleteReceiveDocument.failed(error));
    }
  } catch (error) {
    yield put(ReceiveActions.deleteReceiveDocument.failed(error));
  }
}

function* importReceiveDocument(
  action: PayloadAction<IImportReceiveDocumentRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      ReceiveApiService.importReceiveDocument,
      action.payload
    );
    if (result.succeeded) {
      yield put(ReceiveActions.importReceiveDocument.success(result));
      AlertHelper.showAlert("Import Document Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(ReceiveActions.importReceiveDocument.failed(error));
    }
  } catch (error) {
    yield put(ReceiveActions.importReceiveDocument.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(ReceiveActions.getAllReceives.request, getAllReceives);
  yield takeEvery(ReceiveActions.getReceiveDetail.request, getReceiveDetail);
  yield takeEvery(
    ReceiveActions.getImportPalletDetail.request,
    getImportPalletDetail
  );
  yield takeEvery(
    ReceiveActions.updateReceiveDocument.request,
    updateReceiveDocument
  );
  yield takeEvery(
    ReceiveActions.deleteReceiveDocument.request,
    deleteReceiveDocument
  );

  yield takeEvery(
    ReceiveActions.importReceiveDocument.request,
    importReceiveDocument
  );
}
